module.exports = __webpack_public_path__ + "static/media/homer-donut.d3fb25b5.png";